import React from "react"
import "./Buttons.css"

// component for the confirmation (blue/green) button
// will accept any props including additional className, event listeners, etc
// insert the button's label as a child element to the component

function ConfirmButton({ className, type, ...props }) {
  return (
    <button
      {...props}
      className={
        "btn btn-primary btn-block primary-button-no-margin-hover btn-c button-component" +
        (className ? " " + className : "")
      }
      type={type || "button"}
    />
  )
}

export default ConfirmButton
